import { render, staticRenderFns } from "./ConfigurationTab.vue?vue&type=template&id=3828750c&"
import script from "./ConfigurationTab.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports